import { render, staticRenderFns } from "./calendar_event_item.vue?vue&type=template&id=357cc1e8&scoped=true"
import script from "./calendar_event_item.vue?vue&type=script&lang=js"
export * from "./calendar_event_item.vue?vue&type=script&lang=js"
import style0 from "./calendar_event_item.vue?vue&type=style&index=0&id=357cc1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357cc1e8",
  null
  
)

export default component.exports